import React from "react";
import { IoMdClose } from "react-icons/io";
import styles from "./index.module.scss";

const Close = ({ onClick }) => {
  return (
    <span onClick={onClick} className={styles.close}>
      <IoMdClose />
    </span>
  );
};

export default Close;
